import { connect } from 'react-redux';
import { getPersonContactColumnFields } from 'src/store/selectors/person.selectors';
import { deleteContactRecordBegin } from '../../../../store/actions/person.actions';
import PersonContacts from './PersonContacts';

const mapStateToProps = (state: any) => {
    const contactColumnsFields = getPersonContactColumnFields(state);
    return { contactColumnsFields };
};
const mapDispatchToProps = {
    deleteContact: deleteContactRecordBegin,
};
export default connect(mapStateToProps, mapDispatchToProps)(PersonContacts);
